export const messages = {
  title: '聊天',
  rooms: '会话',
  send: '发送',
  typing: '正在输入…',
  placeholder: '输入消息…',
  empty: '暂无消息',
  noRooms: '还没有会话',
  connected: '已连接',
  reconnecting: '重连中…'
} as const
